import { makeStyles } from "tss-react/mui";
import { MiIcon } from "@miplatform/components";
import { ISSUE_STATUSES } from "@miplatform/constants";
import { MiTHEME } from "@miplatform/theme";
import { mdiThumbDown, mdiThumbUp } from "@mdi/js";
import { Box, Typography } from "@mui/material";

export const INSPECTION_ISSUE_STATUSES_CONFIG = {
  [ISSUE_STATUSES.REPORTED]: {
    label: "Reported",
    borderColor: MiTHEME.palette.warning.main,
    backgroundColor: MiTHEME.palette.warning.accent,
    icon: mdiThumbDown,
  },
  [ISSUE_STATUSES.CLOSED]: {
    label: "Completed",
    borderColor: MiTHEME.palette.green.dark,
    backgroundColor: MiTHEME.palette.green.main,
    icon: mdiThumbUp,
  },
};

export const InspectionIssueStatus = ({
  status,
  date,
}: IInspectionIssueStatusProps) => {
  const { classes } = useStyles();
  const { borderColor, backgroundColor, label, icon } =
    INSPECTION_ISSUE_STATUSES_CONFIG[status] || {};

  return (
    <Box
      className={classes.inspectionStatus}
      bgcolor={backgroundColor}
      borderColor={borderColor}
    >
      <MiIcon path={icon} size={0.75} />
      <Typography variant="BM1">{label}</Typography>
      <Typography variant="BM1">{date}</Typography>
    </Box>
  );
};

const useStyles = makeStyles()((theme) => ({
  inspectionStatus: {
    color: theme.palette.common.white,
    padding: theme.spacing(2),
    overflow: "hidden",
    width: 80,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(0.5),
    alignItems: "center",
    justifyContent: "center",
    borderLeftWidth: 4,
    borderLeftStyle: "solid",
    height: "100%",
  },
}));

export interface IInspectionIssueStatusProps {
  status: string;
  date: string;
}
